export default __webpack_public_path__ + "static/media/Man_picture.f1465a17.PNG";